import './ImageNavigationControls.css';

const ImageNavigationControls = ({ 
    index, 
    totalImages, 
    onPrev, 
    onNext, 
    disabled = false 
}) => {
    return (
        <div className="img-nav">
            <div>
              <strong>Mouse scroll is enabled, use it to navigate images or the buttons below.</strong>
            </div>
            <br/>
            <div>
                <button onClick={onPrev} disabled={disabled || index === 0} className="btn-secondary">Prev</button>
                <button onClick={onNext} disabled={disabled || totalImages === 0 || index === totalImages - 1} className="btn-primary">Next</button>
                <span className="label">{totalImages > 0 ? `${index + 1} / ${totalImages}` : 'No images loaded'}</span>
            </div>
        </div>
    );
};

export default ImageNavigationControls;
